import CopyButton from "./CopyButton";
import { highlight } from "./syntax-highlight";

const TEXT = "#EDEDED";
const TEXT_DIM = "#a0a0a0";
const CARD_BORDER = "rgba(255,255,255,0.04)";

export default async function CodeBlock({ lang, syntax, children }) {
  const text = typeof children === "string" ? children : String(children);
  const highlightedHtml = syntax ? await highlight(text, syntax) : null;

  return (
    <div style={{ margin: "16px 0 24px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 6, minHeight: 22 }}>
        {lang ? (
          <div style={{ fontSize: 10, color: TEXT_DIM, fontFamily: "var(--mono)", textTransform: "uppercase", letterSpacing: "0.08em" }}>{lang}</div>
        ) : <span />}
        <CopyButton text={text} />
      </div>
      {highlightedHtml ? (
        <div dangerouslySetInnerHTML={{ __html: highlightedHtml }} />
      ) : (
        <pre className="code-block" style={{ background: "#0a0a0c", border: `1px solid ${CARD_BORDER}`, borderRadius: 10, padding: "18px 20px", margin: 0, overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          <code style={{ fontSize: 13, lineHeight: 1.7, fontFamily: "var(--mono)", color: TEXT, whiteSpace: "pre" }}>{children}</code>
        </pre>
      )}
    </div>
  );
}
